import { render } from "./Instagram.vue?vue&type=template&id=693f6ae6"
import script from "./Instagram.vue?vue&type=script&lang=js"
export * from "./Instagram.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Instagram.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "693f6ae6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('693f6ae6', __exports__)) {
    api.reload('693f6ae6', __exports__)
  }
  
  module.hot.accept("./Instagram.vue?vue&type=template&id=693f6ae6", () => {
    api.rerender('693f6ae6', render)
  })

}


export default __exports__